import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import {userType} from "../../shared/utils/enums";

export const loggedGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if(auth.user) {
    if (auth.user.kind === userType.etablissement) {
      router.navigateByUrl('/dashboard/accueil');
    } else {
      router.navigateByUrl('/accueil');
    }
    // router.navigateByUrl('/login')
    return false
  }
  return true;
};
